export enum Rules1075 {
	OVERVIEW = 1000,
	REVISIONS = 1000,
	SUBJECT = 2000,
	NEIGHBORHOOD = 3000,
	PROJECTINFORMATION = 4000,
	PROJECTANALYSIS = 4000,
	UNITDESCRIPTION = 5000,
	COMPS = 6000,
	SALESAPPROACH = 7000,
	INCOMEAPPROACH = 7050,
	RECONCILIATION = 8000,
	PDFREVIEW = 9000,
	PHOTOREVIEW = 10000
}
